import { createIcon } from '@integration-frontends/common/ui/icons/create-icon';
import React from 'react';
import './icon-embed.scss';

export const IconEmbed = createIcon(<div className="icon-embed" />);
